import { autoinject } from 'aurelia-framework';

import { Version } from '~/api/settings-api';
import { VersionNumberDialog } from '~/components/version-number/version-number-dialog/version-number-dialog';
import { SettingsState } from '~/settings-state/settings-state';
import { DialogUtils } from '~/utils/dialog-utils';

import styles from '~/components/version-number/version-number.module.scss';

@autoinject
export class VersionNumber {
	/**
	 * styles is forwarding our styles to the *.html template
	 */
	private readonly styles = styles;

	private readonly backendVersion = this.settingsState.state.version;

	constructor(
		private readonly dialogUtils: DialogUtils,
		private readonly settingsState: SettingsState,
	) {}

	private onClickVersion(e: Event) {
		this.dialogUtils.showCustomDialog(VersionNumberDialog, {
			backendVersion: this.backendVersion,
		});
	}
}
